var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCementFloor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9411 24.0548C35.8405 24.1399 35.7322 24.2173 35.6393 24.3102C31.9095 28.04 28.1848 31.7672 24.4653 35.4919C24.3897 35.5736 24.2973 35.638 24.1945 35.6808C24.0916 35.7235 23.9808 35.7435 23.8695 35.7395H14.8003L15.0866 35.43L35.6625 14.854C35.7477 14.7689 35.8483 14.707 35.9411 14.6296V24.0548Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9408 11.6814L35.6623 11.929L24.9371 22.6542C24.8521 22.748 24.772 22.8461 24.6972 22.9482L19.9614 18.2124L20.1317 18.0267L35.7087 2.44195C35.7826 2.37584 35.8601 2.31383 35.9408 2.25623V11.6814Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.074 0.747314C22.0288 0.82385 21.977 0.89634 21.9193 0.963984L12.4554 10.4201C12.4012 10.482 12.3393 10.5284 12.3007 10.5671L7.51843 5.77716C7.62723 5.73985 7.72918 5.68496 7.82022 5.61466L12.409 1.03362C12.4924 0.943244 12.57 0.847614 12.6411 0.747314H22.074Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77026 0.747314L1.09571 9.43733L0.956421 9.53793V0.747314H9.77026Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4398 0.747314C34.3237 0.886602 34.2077 1.02589 34.0839 1.14971L31.0892 4.18309C31.0041 4.27595 30.9344 4.37655 30.857 4.47714L27.1272 0.786008L34.4398 0.747314Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.941 34.2306C35.8094 34.1145 35.6701 33.9984 35.5463 33.8746C34.5403 32.8764 33.5499 31.8782 32.5516 30.8799C32.4588 30.7948 32.3582 30.7252 32.2576 30.6478L35.941 26.918V34.2306Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.263 5.88553L6.11022 29.046L1.46729 24.4031L24.6355 1.23486L29.263 5.88553Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50403 35.7318L18.4216 19.822L23.1264 24.5268C23.0511 24.5673 22.9809 24.6166 22.9175 24.6739L12.084 35.5074C12.0111 35.5838 11.9234 35.6445 11.8263 35.6857C11.7292 35.727 11.6246 35.7479 11.5191 35.7473H2.50403V35.7318Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06382 7.39441L10.7068 12.0373L0.97981 21.8262C0.97981 21.7411 0.97981 21.6482 0.97981 21.5554C0.97981 18.6303 0.97981 15.7053 0.97981 12.7802C0.97503 12.6264 1.02431 12.4758 1.11909 12.3546C2.74412 10.7141 4.37431 9.07877 6.00965 7.44858L6.06382 7.39441Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.971924 34.1067V27.0417L4.50829 30.5781L0.971924 34.1067Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2356 35.7086L30.8029 32.1335L34.3702 35.7086H27.2356Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCementFloor);
export default __webpack_public_path__ + "static/media/cement-floor.b0901a6ca745795b55211cb547d63e3f.svg";
export { ForwardRef as ReactComponent };